import React, { useEffect, useMemo, useState } from "react";
import { useGetLoadStops } from "../../../../services/load/useGetLoadStops";
import { NoSuccessErrorHandler } from "@vahak/core/dist/constants";
import DotLoader from "@vahak/core-ui/dist/components/DotLoader";
import Flex from "@vahak/core-ui/dist/layout/Flex";
import Styles from "./LoadStopsList.module.scss";
import { useGetLatAndLongBasedOnPlaceIdV1 } from "../../../../services/company/useGetLatAndLongBasedOnPlaceIdV1";
import { getJoinedStringFromArray } from "@vahak/core-ui/dist/methods";
import LocationSrcIcon from "@vahak/core/dist/standard-icons/source.svg";
import LocationDestIcon from "@vahak/core/dist/standard-icons/destination.svg";
import GoogleMapIcon from "@vahak/core/dist/icons/google-map-icon.svg";
import Typography from "@vahak/core-ui/dist/components/Typography";
import { ActionObservation } from "@vahak/core-ui/dist/types";
import Chip from "@vahak/core-ui/dist/components/Chip";
import { openGoogleMapsRoute } from "../../../../methods/maps";
import IconWrapper from "@vahak/core-ui/dist/components/IconWrapper";
interface LoadStopsListProps {
    loadId: number;
    // totalDistanceInKm?: number;
}

type ListItem = {
    text: string;
    icon?: React.ReactNode;
    distanceInKm?: number;
    latAndLng?: [number, number];
};
const LoadStopsList = (props: LoadStopsListProps) => {
    const { loadId } = props;
    const [listItem, setListItem] = useState<ListItem[]>();
    const { mutateAsync: getLatAndLong } = useGetLatAndLongBasedOnPlaceIdV1();
    // const [totalDistance, setTotalDistance] = useState( );

    const [actionState, setActionState] = useState<ActionObservation>({
        isLoading: true
    });

    const response = useGetLoadStops(
        { loadId: loadId },
        {
            enabled: !!loadId,
            ...NoSuccessErrorHandler
        }
    );
    const _stopList = response?.data?.data?.stops || [];

    useEffect(() => {
        const method = async () => {
            const [src, ...rest] = _stopList;
            const dest = rest.pop();
            const waypoints = rest;
            try {
                const stopsInfo = [...waypoints]?.sort((a, b) => Number(a.sequence) - Number(b.sequence));

                const formatStopInfo = (info: typeof stopsInfo[number]) => {
                    const { description, address, latitude, longitude } = info || {};
                    return {
                        text: getJoinedStringFromArray([description, address], ", ", true),
                        latAndLng: [latitude, longitude]
                    } as ListItem;
                };

                const result = [
                    {
                        ...formatStopInfo(src),
                        icon: <LocationSrcIcon />
                    },
                    ...stopsInfo.map(
                        (v, ix) =>
                            ({
                                ...formatStopInfo(v),
                                icon: <span className={Styles.dot}>{ix + 1}</span>
                            } as ListItem)
                    ),
                    {
                        ...formatStopInfo(dest!),
                        icon: <LocationDestIcon />
                    }
                ];
                // .map((item, ix, arr) => {
                //     const lastLocationLatLng = arr.at(ix - 1)?.latAndLng;
                //     return {
                //         ...item,
                //         ...(item.latAndLng &&
                //             lastLocationLatLng && {
                //                 distanceInKm: getAerialDistanceInKm(item.latAndLng, lastLocationLatLng)
                //             })
                //     };
                // }) as ListItem[];
                // setTotalDistance(
                //     result?.reduce((previousValue: number, currentValue: ListItem) => {
                //         return previousValue + Number(currentValue?.distanceInKm) || 0;
                //     }, 0)
                // );
                setListItem(result);
            } catch (error) {
                console.error(error);
            } finally {
                setActionState({ isLoading: false });
            }
        };
        _stopList?.length && method();
    }, [_stopList]);

    return (
        <div className={Styles.main}>
            {actionState?.isLoading ? (
                <Flex justifyContent="center" style={{ padding: 20 }}>
                    <DotLoader />
                </Flex>
            ) : (
                <>
                    <div className={Styles.locations}>
                        {listItem?.map((item, ix) => {
                            const allowOpenInGoogleMap = ix == 0;
                            return (
                                <>
                                    <div className={Styles.locationDividerWrapper}>
                                        {ix > 0 && (
                                            <>
                                                <span className={Styles.divider} />
                                                {/* <span className={Styles.distance}>
                                                 <StatusRibbon
                                                     statusText={`${item?.distanceInKm || 0} Km`}
                                                     fillColor={COLORS.GREY_300}
                                                     textColor={COLORS.GREY_1000}
                                                     data-core-ui-status-ribbon-text
                                                 />
                                             </span> */}
                                            </>
                                        )}

                                        <div
                                            className={Styles.location}
                                            {...(allowOpenInGoogleMap && {
                                                onClick: () => openGoogleMapsRoute([item?.latAndLng!]),
                                                style: {
                                                    cursor: "pointer"
                                                }
                                            })}
                                        >
                                            <div className={Styles.locationIcon}>{item?.icon}</div>
                                            <Flex gap={5}>
                                                <Typography weight="semibold">{item?.text}</Typography>
                                                {allowOpenInGoogleMap && (
                                                    <IconWrapper width={20} height={20}>
                                                        <GoogleMapIcon />
                                                    </IconWrapper>
                                                )}
                                            </Flex>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>

                    <Flex alignItems="center" justifyContent="space-between">
                        {/* {!!totalDistance && (
                            <Typography weight="semibold">{`Total Distance : ${totalDistance} Km`}</Typography>
                        )} */}
                        <Chip
                            outlined
                            color="green"
                            leftNode={<GoogleMapIcon />}
                            radius={60}
                            onClick={() => {
                                const list = listItem?.map((v) => v?.latAndLng!);
                                list?.length && openGoogleMapsRoute(list);
                            }}
                        >
                            View in Google map
                        </Chip>
                    </Flex>
                </>
            )}
        </div>
    );
};

export default LoadStopsList;
